import React, { useContext } from "react";

import { FormControlLabel, Grid, Grow, Switch } from "@material-ui/core";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import { EmissaoContext } from "../contexts/EmissaoContext";

import { Margin } from "../styles/Emissao";
import { formatIntegerString } from "../../../../utils/formatIntegerString";

const TabEmissaoExportacaoItem = ({ ...props }) => {
  const {
    productExportDrawbackNumber,
    setProductExportDrawbackNumber,
    productIsIndirectExportation,
    setProductIsIndirectExportation,
    productExportRegisterNumber,
    setProductExportRegisterNumber,
    productExportAccessKey,
    setProductExportAccessKey,
    productExportQuantity,
    setProductExportQuantity,
    productError,
  } = useContext(ParametrosProdutoContext);

  const { visualizationOnly } = useContext(EmissaoContext);

  const handleChangeIndirectExportation = () => {
    setProductIsIndirectExportation((current) => !current);

    if (!productIsIndirectExportation) {
      setProductExportRegisterNumber(null);
      setProductExportAccessKey(null);
      setProductExportQuantity("0,0000");
    }
  };

  return (
    <Grid container spacing={2}>
      <Grow in={true}>
        <Grid item lg={12} sm={12}>
          <Card line="left">
            <Margin top="10" bottom="10">
              <Grid container spacing={2}>
                <Grid item sm={4}>
                  <TextField
                    value={productExportDrawbackNumber}
                    setValue={setProductExportDrawbackNumber}
                    label="Nº Drawback"
                    onChange={({ target: { value } }) => {
                      setProductExportDrawbackNumber(
                        formatIntegerString(value, 11)
                      );
                    }}
                    error={
                      productError.productExportDrawbackNumber ? true : false
                    }
                    helperText={productError.productExportDrawbackNumber || ""}
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={6}>
                  <FormControlLabel
                    value="end"
                    control={
                      <Switch
                        checked={productIsIndirectExportation}
                        onChange={handleChangeIndirectExportation}
                        color="primary"
                      />
                    }
                    label="Exportação Indireta?"
                    labelPlacement="end"
                    disabled={visualizationOnly}
                  />
                </Grid>
              </Grid>
              {productIsIndirectExportation && (
                <Grid container spacing={2}>
                  <Grid item sm={4}>
                    <TextField
                      value={productExportRegisterNumber}
                      setValue={setProductExportRegisterNumber}
                      label="Registro Exportação"
                      onChange={({ target: { value } }) => {
                        setProductExportRegisterNumber(
                          formatIntegerString(value, 12)
                        );
                      }}
                      error={
                        productError.productExportRegisterNumber ? true : false
                      }
                      helperText={
                        productError.productExportRegisterNumber || ""
                      }
                      disabled={visualizationOnly}
                    />
                  </Grid>
                  <Grid item sm={5}>
                    <TextField
                      value={productExportAccessKey}
                      setValue={setProductExportAccessKey}
                      label="Chave NF-e"
                      onChange={({ target: { value } }) => {
                        setProductExportAccessKey(
                          formatIntegerString(value, 44)
                        );
                      }}
                      error={productError.productExportAccessKey ? true : false}
                      helperText={productError.productExportAccessKey || ""}
                      disabled={visualizationOnly}
                    />
                  </Grid>
                  <Grid item sm={3}>
                    <TextField
                      value={productExportQuantity}
                      setValue={setProductExportQuantity}
                      label="Qtd. Exportada"
                      mask="decimal"
                      maxLength={19}
                      decimals={4}
                      error={productError.productExportQuantity ? true : false}
                      helperText={productError.productExportQuantity || ""}
                      disabled={visualizationOnly}
                    />
                  </Grid>
                </Grid>
              )}
            </Margin>
          </Card>
        </Grid>
      </Grow>
    </Grid>
  );
};

export default TabEmissaoExportacaoItem;
